/* eslint-disable */
import {
  mdiViewDashboard,
  mdiAccountAlert,
  mdiBusDoubleDecker,
  mdiAccountArrowLeft,
  mdiAccountArrowLeftOutline,
  mdiFaceAgent,
  mdiAccountCircle,
  mdiAccountGroup,
  mdiSchool,
  mdiBookOpenVariant,
  mdiBookshelf,
  mdiBookOpenPageVariant,
  mdiBookPlusMultiple,
  mdiHammerScrewdriver,
  mdiFormatListBulletedType,
  mdiFormatLetterMatches,
  mdiNumeric9BoxMultiple,
  mdiNotebookEdit,
  mdiAccountDetails,
  mdiTimetable,
  mdiCalendarMonth,
  mdiTimelineClockOutline,
  mdiPuzzle,
  mdiConsoleNetworkOutline,
  mdiSoccer,
  mdiClipboardAccount,
  mdiClipboardAccountOutline,
  mdiQrcodeScan,
  mdiEyeCheckOutline,
  mdiNotebookCheck,
  mdiRunFast,
  mdiTrophyOutline,
  mdiClipboardText,
  mdiAccountCheckOutline
} from "@mdi/js";
// const roles = localStorage.getItem('roles')
const menuTeacher = [
  {
    to: "/comboard-dashboard",
    icon: mdiViewDashboard,
    label: "sidebar.dashboard",
  },
  {
    label: "sidebarTeacher.student",
    // label: "Student",
    subLabel: "Submenus Student",
    icon: mdiAccountCircle,
    menu: [
      {
        to: "/students",
        label: "sidebarTeacher.student",
        // label: "Students Data",
        icon: mdiAccountGroup,
      },
      {
        to: "/non-academic-activity",
        label: "sidebarTeacher.nonAcademicActivity",
        // label: "Non-Academic Activities",
        icon: mdiRunFast,
      },
      {
        to: "/student-achievement",
        label: "sidebarTeacher.studentAchievement",
        // label: "Student Achievement",
        icon: mdiTrophyOutline,
      },
      // {
      // 	to: '/student-doc',
      // 	label: 'Student Documents',
      // 	icon: mdiAccountGroup
      // },
      // {
      // 	to: '/parentuser',
      // 	label: 'Parents',
      // 	icon: mdiAccount
      // },
      // {
      // 	to: '/',
      // 	label: 'Users',
      // 	icon: mdiAccountMultiple
      // },
      // {
      // 	to: '/class-transfer',
      // 	label: 'Class Transfer',
      // 	icon: mdiAccountMultiplePlus
      // },
      // {
      // 	to: '/student-resignation',
      // 	label: 'Resignation',
      // 	icon: mdiAccountGroup
      // },
      // {
      // 	to: '/graduation',
      // 	label: 'Graduation',
      // 	icon: mdiAccountSchool
      // }
    ],
  },
  {
    label: "sidebarTeacher.permissionRequest",
    // label: "Permission Request",
    subLabel: "Submenus Teacher",
    icon: mdiFaceAgent,
    menu: [
      {
        to: "/permissions",
        label: "sidebarTeacher.permission",
        // label: "Permissions",
        icon: mdiFaceAgent,
      },
      {
        to: "/permission-reason",
        label: "sidebarTeacher.permissionReason",
        // label: "Permission Reason",
        icon: mdiFaceAgent,
      },
    ],
  },
  {
    label: "sidebarTeacher.attendance",
    // label: "Attendance",
    subLabel: "Submenus Attendance",
    icon: mdiAccountArrowLeft,
    menu: [
      {
        to: "/daily-attendance",
        label: "sidebarTeacher.dailyAttendance",
        // label: "Daily Attendance",
        icon: mdiConsoleNetworkOutline,
      },
      {
        to: "/regular-subject-attendance",
        label: "sidebarTeacher.regularSubject",
        // label: "Regular Subject",
        icon: mdiAccountArrowLeftOutline,
      },
      {
        to: "/parallel-subject",
        label: "sidebarTeacher.parallelSubject",
        // label: "Parallel Subject",
        icon: mdiAccountArrowLeftOutline,
      },
      {
        to: "/report-attendance-daily",
        label: "sidebarTeacher.dailyAttendanceReport",
        // label: "Daily Attendance Report",
        icon: mdiAccountAlert,
      },
      {
        to: "/assignment-special",
        label: "sidebarTeacher.specialAssignment",
        // label: "Special Assignment",
        icon: mdiBusDoubleDecker,
      },
    ],
  },
  {
    label: "sidebarTeacher.schedule",
    // label: "Schedule",
    subLabel: "Submenus Schedule",
    icon: mdiTimetable,
    menu: [
      // 	{
      // 	to: '/schooltime',
      // 	label: 'School Time',
      // 	icon: mdiAvTimer
      // },
      // {
      // 	to: '/studytime',
      // 	label: 'Study Time',
      // 	icon: mdiAvTimer
      // },
      {
        to: "/schedule",
        label: "sidebarTeacher.schedule",
        // label: "Schedule",
        icon: mdiTimetable,
      },
      {
        to: "/extracuricular-schedule",
        label: "sidebarTeacher.extracuricularSchedule",
        // label: "Extracuricular Schedule",
        icon: mdiTimetable,
      },
      {
        to: "/calendar",
        label: "sidebarTeacher.calendar",
        // label: "Calendar",
        icon: mdiCalendarMonth,
      },
    ],
  },
  {
    label: "sidebarTeacher.subject",
    // label: "Subject",
    subLabel: "Submenus Subject",
    icon: mdiBookOpenVariant,
    menu: [
      {
        to: "/subject",
        label: "sidebarTeacher.subject",
        // label: "Subject",
        icon: mdiBookshelf,
      },
      {
        to: "/subject-group",
        label: "sidebarTeacher.subjectGroup",
        // label: "Subject Group",
        icon: mdiBookOpenPageVariant,
      },
      {
        to: "/learning-method",
        label: "sidebarTeacher.learningMethod",
        // label: "Learning Method",
        icon: mdiBookPlusMultiple,
      },
      {
        to: "/grading-aspects",
        label: "sidebarTeacher.gradingAspects",
        // label: "Grading Aspects",
        icon: mdiHammerScrewdriver,
      },
      {
        to: "/aspect-academic-year",
        label: "sidebarTeacher.aspectAcademicYear",
        // label: "Aspect Academic Year",
        icon: mdiCalendarMonth,
      },
      {
        to: "/aspect-assignment-level",
        label: "sidebarTeacher.aspectAssignmentLevel",
        // label: "Aspect Assignment Level",
        icon: mdiClipboardText,
      },
      {
        to: "/assignment-type",
        label: "sidebarTeacher.assignmentType",
        // label: "Assignment Type",
        icon: mdiFormatListBulletedType,
      },
      {
        to: "/grading-rule",
        label: "sidebarTeacher.gradingRule",
        // label: "Grading Rule",
        icon: mdiFormatLetterMatches,
      },
      {
        to: "/final-score-rule",
        label: "sidebarTeacher.finalScoreRule",
        // label: "Final Score Rule",
        icon: mdiNumeric9BoxMultiple,
      },
      {
        to: "/scoreminimum",
        label: "sidebarTeacher.passingGrade",
        // label: "Passing Grade",
        icon: mdiNumeric9BoxMultiple,
      },
      {
        to: "/syllabus",
        label: "sidebarTeacher.syllabus",
        // label: "Syllabus",
        icon: mdiNotebookEdit,
      },
      {
        to: "/teaching-time-plan",
        label: "sidebarTeacher.teachingTimePlan",
        // label: "Teaching Timeplan",
        icon: mdiTimelineClockOutline,
      },
      {
        to: "/lesson-plan",
        label: "sidebarTeacher.lessonPlan",
        // label: "Lesson Plan",
        icon: mdiPuzzle,
      },
      {
        to: "/student-paralel-subject",
        label: "sidebarTeacher.studentParallelSubject",
        // label: "Student Parallel Subject",
        icon: mdiAccountDetails,
      },
      {
        to: "/student-select-subject",
        label: "sidebarTeacher.studentSubjectSelection",
        // label: "Student Subject Selection",
        icon: mdiAccountDetails,
      },
    ],
  },
  {
    label: "sidebarTeacher.extracuricular",
    // label: "Extracuricular",
    subLabel: "Submenus Extracuricular",
    icon: mdiSoccer,
    menu: [
      {
        to: "/extracuricular",
        label: "sidebarTeacher.extracuricular",
        // label: "Extracuricular",
        icon: mdiSoccer,
      },
      {
        to: "/extracuricular-group",
        label: "sidebarTeacher.extracuricularGroup",
        // label: "Extracuricular Group",
        icon: mdiSoccer,
      },
      {
        to: "/extracuricular-student",
        label: "sidebarTeacher.extracuricularStudent",
        // label: "Student Extracuricular",
        icon: mdiAccountDetails,
      },
      {
        to: "/extracuricular-student-select",
        label: "sidebarTeacher.extracuricularStudentSelection",
        // label: "Student Extracuricular Selection",
        icon: mdiAccountDetails,
      },
      {
        to: '/extracuricular-attendance',
        label: 'Extracuricular Attendance',
        icon: mdiAccountCheckOutline
      }
      // {
      // 	to: '/extracuricularbarchart',
      // 	label: 'Report Extracuricular',
      // 	icon: mdiAccountDetails
      // }
    ],
  },
  {
    label: "sidebarTeacher.teacher",
    // label: "Teacher",
    subLabel: "Submenus Teacher",
    icon: mdiClipboardAccount,
    menu: [
      {
        to: "/teacher",
        label: "sidebarTeacher.teacher",
        // label: "Teacher",
        icon: mdiClipboardAccountOutline,
      },
      {
        to: "/teacher-extracuricular",
        label: "sidebarTeacher.extracurricularTeacher",
        // label: "Extracurricular Teacher",
        icon: mdiSoccer,
      },
      {
        to: "/teacher-note",
        label: "sidebarTeacher.teacherNote",
        // label: "Teacher Note",
        icon: mdiAccountDetails,
      },
      {
        to: "/scan-asset",
        label: "sidebarTeacher.scanAsset",
        // label: "Scan Asset",
        icon: mdiQrcodeScan,
      },
      {
        to: "/scan-asset-location",
        label: "sidebarTeacher.scanAssetLocation",
        // label: "Scan Asset Location",
        icon: mdiQrcodeScan,
      },
      // {
      // 	to: '/teacherjournal',
      // 	label: 'Teacher Journal',
      // 	icon: mdiFileDocument
      // }
      {
        to: '/student-observation',
        label: 'sidebarTeacher.studentObservation',
        // label: 'Student Observation',
        icon: mdiEyeCheckOutline
      },
      {
        to: '/completed-coursework',
        label: 'sidebarTeacher.completedCoursework',
        // label: 'Completed Coursework',
        icon: mdiNotebookCheck
      }
    ],
  },
  {
    label: "sidebarTeacher.subjectAssessment",
    // label: "Subject Assessment",
    subLabel: "Submenus Subject Assessment",
    icon: mdiSchool,
    menu: [
      {
        to: "/lesson-assessment-regular",
        label: "sidebarTeacher.regular",
        // label: "Regular",
        icon: mdiSchool,
      },
      {
        to: "/lesson-assessment-parallel",
        label: "sidebarTeacher.parallel",
        // label: "Parallel",
        icon: mdiSchool,
      },
      {
        to: "/ledger-homeroom-attidude",
        label: "sidebarTeacher.homeroomLedgerKokurikuler",
        // label: "Homeroom Ledger Kokurikuler",
        icon: mdiSchool,
      },
      {
        to: "/ledger-homeroom-teacher",
        label: "sidebarTeacher.homeroomLedger",
        // label: "Homeroom Ledger",
        icon: mdiSchool,
      },
      {
        to: "/extracuricular-score",
        label: "sidebarTeacher.extracuricularScore",
        // label: "Extracuricular Score",
        icon: mdiSchool,
      },
    ],
  },
  {
    label: "sidebarTeacher.report",
    // label: "Report",
    to: "/student-raport",
    icon: mdiSchool,
  },
];
export default menuTeacher;
